import React from 'react';

const NbnEnterprisePlan = ({ item }) => {

    return (
        <div className="nbn-ee-plan text-center">
            <h5 className="bold m-0 color-lime">nbn™ Enterprise Ethernet</h5>
            <p className="price bold mb-0 mt-2">{item.speed}</p>
            <p className="font-small m-0 mb-2">{item.description}</p>
            <hr />
            <p className="bold data m-0">From ${item.price}/mth</p>
            <p className="m-0 mb-2">
                <small>Excludes GST. CBD Zone Price on Low CoS.</small>
            </p>
            <h6>Unlimited data</h6>
            <hr />
            <p className="m-0 bold font-large">Free installation</p>
            <p className="m-0 font-small">on 36mth contract (select locations)</p>
            <hr />
            <p className="m-0 font-small bold">Symmetrical connection</p>
            <p className="m-0 font-small bold">Faster fault resolution</p>
            <p className="m-0 font-small bold">nbn™ Premium | 99.95% network availability</p>
            <div className="min-cost text-center font-tiny color-white pt-3">
                Total min cost: {item.minCost}
            </div>
        </div>
    )
}
export default NbnEnterprisePlan


// WEBPACK FOOTER //
// ./resources/assets/js/components/NbnEnterprisePlan.js